<div class="container">
  <div>
    <strong><span>PRIVACY NOTICE</span></strong>
  </div>
  <div> </div>
  <div>
    <strong><span>Last updated February 12, 2026</span></strong>
  </div>
  <div> </div>
  <div> </div>
  <div> </div>
  <div>
    <span>Thank you for choosing to be part of our community at Dealforager. LLC
      ("<strong>Company</strong></span><span>", "<strong>we</strong>", "<strong>us</strong>", "<strong>our</strong>").
      We are committed to protecting your personal information and your right to
      privacy. If you have any questions or concerns about this privacy notice,
      or our practices with regards to your personal information, please contact
      us at admin&#64;dealforager.com.</span>
  </div>
  <div> </div>
  <div>
    <span>When you visit our website
      <a href="http://www.dealforager.com">http://www.dealforager.com</a> (the
      "<strong>Website</strong>"), and more generally, use any of our services
      (the "<strong>Services</strong>", which include the </span><span><span>Website</span></span><span>), we appreciate
      that you are trusting us with your personal information.
      We take your privacy very seriously. In this privacy notice, we seek to
      explain to you in the clearest way possible what information we collect,
      how we use it and what rights you have in relation to it. We hope you take
      some time to read through it carefully, as it is important. If there are
      any terms in this privacy notice that you do not agree with, please
      discontinue use of our Services immediately.</span>
  </div>
  <div> </div>
  <div>
    <span>This privacy notice applies to all information collected through our
      Services (which, as described above, includes our </span><span>Website</span><span>), as well as, any related
      services, sales, marketing or events.</span>
  </div>
  <div> </div>
  <div>
    <span><strong>Please read this privacy notice carefully as it will help you
        understand what we do with the information that we collect.</strong></span>
  </div>
  <div> </div>
  <div>
    <strong><span>1. WHAT INFORMATION DO WE COLLECT?</span></strong>
  </div>
  <div>
    <span><strong><u><br /></u></strong><strong>Information automatically collected</strong></span>
  </div>
  <div>
    <div> </div>
    <div>
      <span><span><strong><em>In Short: </em></strong></span></span><span><span><strong><em> </em></strong><em>Some
            information — such as your Internet Protocol (IP) address
            and/or browser and device characteristics — is collected
            automatically when you visit our
            <span><em><span><span>Website</span></span></em></span>.</em></span></span>
    </div>
  </div>
  <div> </div>
  <div>
    <span>We automatically collect certain information when you visit, use or
      navigate the <span>Website</span>. This information does not reveal your
      specific identity (like your name or contact information) but may include
      device and usage information, such as your IP address, browser and device
      characteristics, operating system, language preferences, referring URLs,
      device name, country, location, information about how and when you use our
      <span>Website</span> and other technical information. This information is
      primarily needed to maintain the security and operation of our
      <span>Website</span>, and for our internal analytics and reporting
      purposes.</span>
  </div>
  <div> </div>
  <div>
    <span>Like many businesses, we also collect information through cookies and
      similar technologies.
    </span>
  </div>
  <div> </div>
  <div><span>The information we collect includes:</span></div>
  <ul>
    <li>
      <span><em>Log and Usage Data.</em> Log and usage data is service-related,
        diagnostic, usage and performance information our servers automatically
        collect when you access or use our <span><span>Website</span></span> and
        which we record in log files. Depending on how you interact with us,
        this log data may include your IP address, device information, browser
        type and settings and information about your activity in the
        <span><span>Website</span></span> (such as the date/time stamps associated with your usage, pages and
        files viewed, searches and other actions you take such as which features
        you use), device event information (such as system activity, error
        reports (sometimes called 'crash dumps') and hardware settings).</span>
    </li>
  </ul>
  <div> </div>
  <ul>
    <li>
      <span><em>Device Data.</em> We collect device data such as information about
        your computer, phone, tablet or other device you use to access the
        <span>Website</span>. Depending on the device used, this device data may
        include information such as your IP address (or proxy server), device
        and application identification numbers, location, browser type, hardware
        model Internet service provider and/or mobile carrier, operating system
        and system configuration information.</span>
    </li>
  </ul>
  <div> </div>
  <ul>
    <li>
      <span><em>Location Data.</em> We collect location data such as information
        about your device's location, which can be either precise or imprecise.
        How much information we collect depends on the type and settings of the
        device you use to access the <span><span>Website</span></span>. For example, we may use GPS and other
        technologies to collect
        geolocation data that tells us your current location (based on your IP
        address). You can opt out of allowing us to collect this information
        either by refusing access to the information or by disabling your
        Location setting on your device. Note however, if you choose to opt out,
        you may not be able to use certain aspects of the Services.</span>
    </li>
  </ul>
  <div> </div>
  <div> </div>
  <div>
    <strong><span>2. HOW DO WE USE YOUR INFORMATION?</span></strong>
  </div>
  <div>
    <div> </div>
    <div>
      <span><span><strong><em>In Short:  </em></strong><em>We process your information for purposes based on legitimate
            business interests, the fulfillment of our contract with you,
            compliance with our legal obligations, and/or your consent.</em></span></span>
    </div>
  </div>
  <div> </div>
  <div>
    <span>We use personal information collected via our <span>Website</span> for a
      variety of business purposes described below. We process your personal
      information for these purposes in reliance on our legitimate business
      interests, in order to enter into or perform a contract with you, with
      your consent, and/or for compliance with our legal obligations. We
      indicate the specific processing grounds we rely on next to each purpose
      listed below.</span>
  </div>
  <div> </div>
  <div>
    <span>We use the information we collect or receive:</span>
    <div>
      <div>
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div>
                        <div> </div>
                        <ul>
                          <li>
                            <span><strong>For other business purposes.</strong></span><span> We may use your information
                              for other business
                              purposes, such as data analysis, identifying usage
                              trends, determining the effectiveness of our
                              promotional campaigns and to evaluate and improve
                              our <span><span>Website</span></span>, products, marketing and your experience. We may
                              use and store this information in aggregated and
                              anonymized form so that it is not associated with
                              individual end users and does not include personal
                              information. We will not use identifiable personal
                              information without your consent.</span>
                          </li>
                        </ul>
                        <div> </div>
                        <div> </div>
                        <div>
                          <strong><span>3. WILL YOUR INFORMATION BE SHARED WITH
                              ANYONE?</span></strong>
                        </div>
                        <div> </div>
                        <div>
                          <span><strong><em>In Short:</em></strong><em>  We only share information with your consent, to
                              comply with laws, to provide you with services, to
                              protect your rights, or to fulfill business
                              obligations.</em></span>
                        </div>
                        <div> </div>
                        <div>
                          <span>We may process or share your data that we hold
                            based on the following legal basis:</span>
                        </div>
                        <ul>
                          <li>
                            <span><strong>Consent:</strong> We may process your
                              data if you have given us specific consent to use
                              your personal information for a specific
                              purpose.</span>
                          </li>
                        </ul>
                        <div> </div>
                        <ul>
                          <li>
                            <span><strong>Legitimate Interests:</strong> We may
                              process your data when it is reasonably necessary
                              to achieve our legitimate business
                              interests.</span>
                          </li>
                        </ul>
                        <div> </div>
                        <ul>
                          <li>
                            <span><strong>Performance of a Contract:</strong> Where
                              we have entered into a contract with you, we may
                              process your personal information to fulfill the
                              terms of our contract.</span>
                          </li>
                        </ul>
                        <div> </div>
                        <ul>
                          <li>
                            <span><strong>Legal Obligations:</strong> We may
                              disclose your information where we are legally
                              required to do so in order to comply with
                              applicable law, governmental requests, a judicial
                              proceeding, court order, or legal process, such as
                              in response to a court order or a subpoena
                              (including in response to public authorities to
                              meet national security or law enforcement
                              requirements).</span>
                          </li>
                        </ul>
                        <div> </div>
                        <ul>
                          <li>
                            <span><strong>Vital Interests:</strong> We may disclose
                              your information where we believe it is necessary
                              to investigate, prevent, or take action regarding
                              potential violations of our policies, suspected
                              fraud, situations involving potential threats to
                              the safety of any person and illegal activities,
                              or as evidence in litigation in which we are
                              involved.</span>
                          </li>
                        </ul>
                        <div>
                          <span>More specifically, we may need to process your data
                            or share your personal information in the following
                            situations:</span>
                        </div>
                        <ul>
                          <li>
                            <span><strong>Business Transfers.</strong> We may share
                              or transfer your information in connection with,
                              or during negotiations of, any merger, sale of
                              company assets, financing, or acquisition of all
                              or a portion of our business to another
                              company.</span>
                          </li>
                        </ul>
                        <div>
                          <div>
                            <div>
                              <div>
                                <div>
                                  <div>
                                    <div> </div>
                                    <div> </div>
                                    <div> </div>
                                    <div>
                                      <strong><span>4. DO WE USE COOKIES AND OTHER
                                          TRACKING TECHNOLOGIES?</span></strong>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span><strong><em>In Short: </em></strong><em> We may use cookies and other
                                          tracking technologies to collect and
                                          store your information.</em></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>We may use cookies and similar tracking
                                        technologies (like web beacons and
                                        pixels) to access or store information.
                                        Specific information about how we use
                                        such technologies and how you can refuse
                                        certain cookies is set out in our Cookie
                                        Notice<span>.</span></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <strong><span>5. IS YOUR INFORMATION TRANSFERRED
                                          INTERNATIONALLY?</span></strong>     
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span><strong><em>In Short:  </em></strong><em>We may transfer, store, and process
                                          your information in countries other
                                          than your own.</em></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>Our servers are located in. If you are
                                        accessing our
                                        <span><span><span><span>Website</span></span></span></span>
                                        from outside, please be aware that your
                                        information may be transferred to,
                                        stored, and processed by us in our
                                        facilities and by those third parties
                                        with whom we may share your personal
                                        information (see "<a href="#infoshare">WILL YOUR INFORMATION BE SHARED WITH
                                          ANYONE?</a>" above), in and other countries.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>If you are a resident in the European
                                        Economic Area, then these countries may
                                        not necessarily have data protection
                                        laws or other similar laws as
                                        comprehensive as those in your country.
                                        We will however take all necessary
                                        measures to protect your personal
                                        information in accordance with this
                                        privacy notice and applicable law.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <strong><span>6. HOW LONG DO WE KEEP YOUR
                                          INFORMATION?</span></strong>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span><strong><em>In Short: </em></strong><em> We keep your information for as
                                          long
                                          as necessary to fulfill the purposes
                                          outlined in this privacy notice unless
                                          otherwise required by law.</em></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>We will only keep your personal
                                        information for as long as it is
                                        necessary for the purposes set out in
                                        this privacy notice, unless a longer
                                        retention period is required or
                                        permitted by law (such as tax,
                                        accounting or other legal requirements).
                                        No purpose in this notice will require
                                        us keeping your personal information for
                                        longer than <span>90 days</span>.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>When we have no ongoing legitimate
                                        business need to process your personal
                                        information, we will either delete or
                                        anonymize such information, or, if this
                                        is not possible (for example, because
                                        your personal information has been
                                        stored in backup archives), then we will
                                        securely store your personal information
                                        and isolate it from any further
                                        processing until deletion is
                                        possible.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <strong><span>7. HOW DO WE KEEP YOUR INFORMATION
                                          SAFE?</span></strong>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span><strong><em>In Short: </em></strong><em> We aim to protect your personal
                                          information through a system of
                                          organizational and technical security
                                          measures.</em></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>We have implemented appropriate
                                        technical and organizational security
                                        measures designed to protect the
                                        security of any personal information we
                                        process. However, despite our safeguards
                                        and efforts to secure your information,
                                        no electronic transmission over the
                                        Internet or information storage
                                        technology can be guaranteed to be 100%
                                        secure, so we cannot promise or
                                        guarantee that hackers, cybercriminals,
                                        or other unauthorized third parties will
                                        not be able to defeat our security, and
                                        improperly collect, access, steal, or
                                        modify your information. Although we
                                        will do our best to protect your
                                        personal information, transmission of
                                        personal information to and from our
                                        <span><span><span>Website</span></span></span>
                                        is at your own risk. You should only
                                        access the
                                        <span><span><span>Website</span></span></span>
                                        within a secure environment.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <strong><span>8. DO WE COLLECT INFORMATION FROM
                                          MINORS?</span></strong>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span><strong><em>In Short:</em></strong><em>  We do not knowingly collect data
                                          from or market to children under 18
                                          years of age.</em></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>We do not knowingly solicit data from
                                        or market to children under 18 years of
                                        age. By using the
                                        <span><span><span>Website</span></span></span>, you represent that you are at
                                        least
                                        18 or that you are the parent or
                                        guardian of such a minor and consent to
                                        such minor dependent’s use of the
                                        <span><span><span>Website</span></span></span>. If we learn that personal
                                        information
                                        from users less than 18 years of age has
                                        been collected, we will deactivate the
                                        account and take reasonable measures to
                                        promptly delete such data from our
                                        records. If you become aware of any data
                                        we may have collected from children
                                        under age 18, please contact us at
                                        <span>admin&#64;dealforager.com</span>.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <strong><span>9. WHAT ARE YOUR PRIVACY
                                          RIGHTS?</span></strong>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span><strong><em>In Short:</em></strong><em>  You may review, change, or
                                          terminate your account at any
                                          time.</em></span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>If you are a resident in the European
                                        Economic Area and you believe we are
                                        unlawfully processing your personal
                                        information, you also have the right to
                                        complain to your local data protection
                                        supervisory authority. You can find
                                        their contact details here:
                                        <span><span><a
                                              href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a></span></span>.</span>
                                    </div>
                                    <div> </div>
                                    <div>
                                      <span>If you are a resident in Switzerland,
                                        the contact details for the data
                                        protection authorities are available
                                        here:
                                        <span><span><a
                                              href="https://www.edoeb.admin.ch/edoeb/en/home.html">https://www.edoeb.admin.ch/edoeb/en/home.html</a></span></span>.</span>
                                    </div>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span><strong><u>Cookies and similar technologies:</u></strong>
                                      Most Web browsers are set to accept
                                      cookies by default. If you prefer, you can
                                      usually choose to set your browser to
                                      remove cookies and to reject cookies. If
                                      you choose to remove cookies or reject
                                      cookies, this could affect certain
                                      features or services of our
                                      <span><span><span><span>Website</span></span></span></span>. To opt-out of
                                      interest-based
                                      advertising by advertisers on our
                                      <span><span><span><span>Website</span></span></span></span>
                                      visit
                                      <span><a
                                          href="http://www.aboutads.info/choices/">http://www.aboutads.info/choices/</a></span>.
                                    </span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <strong><span>10. CONTROLS FOR DO-NOT-TRACK
                                        FEATURES</span></strong>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span>Most web browsers and some mobile
                                      operating systems and mobile applications
                                      include a Do-Not-Track ("DNT") feature or
                                      setting you can activate to signal your
                                      privacy preference not to have data about
                                      your online browsing activities monitored
                                      and collected. At this stage no uniform
                                      technology standard for recognizing and
                                      implementing DNT signals has been
                                      finalized. As such, we do not currently
                                      respond to DNT browser signals or any
                                      other mechanism that automatically
                                      communicates your choice not to be tracked
                                      online. If a standard for online tracking
                                      is adopted that we must follow in the
                                      future, we will inform you about that
                                      practice in a revised version of this
                                      privacy notice.</span> 
                                  </div>
                                  <div> </div>
                                  <div>
                                    <strong><span>11. DO CALIFORNIA RESIDENTS HAVE
                                        SPECIFIC PRIVACY RIGHTS?</span></strong>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span><strong><em>In Short: </em></strong><em> Yes, if you are a resident of
                                        California, you are granted specific
                                        rights regarding access to your personal
                                        information.</em></span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span>California Civil Code Section 1798.83,
                                      also known as the "Shine The Light" law,
                                      permits our users who are California
                                      residents to request and obtain from us,
                                      once a year and free of charge,
                                      information about categories of personal
                                      information (if any) we disclosed to third
                                      parties for direct marketing purposes and
                                      the names and addresses of all third
                                      parties with which we shared personal
                                      information in the immediately preceding
                                      calendar year. If you are a California
                                      resident and would like to make such a
                                      request, please submit your request in
                                      writing to us using the contact
                                      information provided below.</span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span>If you are under 18 years of age, reside
                                      in California, and have a registered
                                      account with
                                      <span><span><span>the Website</span></span></span>, you have the right to request
                                      removal
                                      of unwanted data that you publicly post on
                                      the
                                      <span><span><span>Website</span></span></span>. To request removal of such data,
                                      please
                                      contact us using the contact information
                                      provided below, and include the email
                                      address associated with your account and a
                                      statement that you reside in California.
                                      We will make sure the data is not publicly
                                      displayed on the
                                      <span><span><span>Website</span></span></span>, but please be aware that the data
                                      may
                                      not be completely or comprehensively
                                      removed from all our systems (e.g.
                                      backups, etc.).</span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <strong><span>12. DO WE MAKE UPDATES TO THIS
                                        NOTICE?</span></strong>     
                                  </div>
                                  <div><em> </em></div>
                                  <div>
                                    <span><em><strong>In Short: </strong> Yes, we
                                        will update this notice as necessary to
                                        stay compliant with relevant laws.</em></span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span>We may update this privacy notice from
                                      time to time. The updated version will be
                                      indicated by an updated "Revised" date and
                                      the updated version will be effective as
                                      soon as it is accessible. If we make
                                      material changes to this privacy notice,
                                      we may notify you either by prominently
                                      posting a notice of such changes or by
                                      directly sending you a notification. We
                                      encourage you to review this privacy
                                      notice frequently to be informed of how we
                                      are protecting your information.</span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <strong><span>13. HOW CAN YOU CONTACT US ABOUT THIS
                                        NOTICE?</span></strong>     
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span>If you have questions or comments about
                                      this notice, you may
                                      <span>email us at admin&#64;dealforager.com</span><span> or by post
                                        to:</span></span>
                                  </div>
                                  <div> </div>
                                  <div>
                                    <strong><span>14. HOW CAN YOU REVIEW, UPDATE, OR
                                        DELETE THE DATA WE COLLECT FROM
                                        YOU?</span></strong>     
                                  </div>
                                  <div> </div>
                                  <div>
                                    <span>Based on the applicable laws of your
                                      country, you may have the right to request
                                      access to the personal information we
                                      collect from you, change that information,
                                      or delete it in some circumstances. To
                                      request to review, update, or delete your
                                      personal information, please submit a
                                      request form by clicking </span><span><a
                                        href="https://app.termly.io/notify/8f54978e-bf1e-4285-a8ed-c65d358963ed">here</a></span><span>.
                                      We will respond to your request within
                                      30 days.</span>
                                  </div>
                                </div>
                                <div> </div>
                                <div> </div>
                                <div>
                                  This privacy policy was created using
                                  <a href="https://termly.io/products/privacy-policy-generator/?ftseo">Termly’s Privacy
                                    Policy Generator</a>.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>